export const TRIGGERED_ALERTS_PAGE_FILTERS_IDS = {
  severities: 'severities',
};
